import {EAuthRole} from "../types/auth";

function fn(role: EAuthRole): boolean {
    return role === EAuthRole.SUPER_ADMIN;
}

export default fn;
